// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3Z050","title":"Images45_title__2jyHf","images":"Images45_images__2wrmy"};